<template>
    <div>
        <b-alert show variant="text-white">
        <div class="row py-2 ml-4">
            <div class="col-12">
            <h6 class="heading-small text-muted mb-3">กรอกหมายเลขพัสดุ</h6>
                <form @submit.prevent="validateTracking()">
                    <div class="row d-flex justify-content-center">
                        <div class="col-9 pl-4">
                        <input
                            ref="searchTracking"
                            type="text"
                            class="form-control m-1"
                            :class="{'has-error':isError.errorMsg}"
                            :placeholder="isPlaceholder"
                            @change="clearError($event)"
                            v-on:keyup="clearError($event)"
                            v-model="isTracking.trackingCode"
                        />
                        </div>
                        <div class="col-3">
                        <b-button 
                            variant="primary" 
                            class="m-1"
                            :disabled="isTracking.trackingCode.length < 11 || isLoading"
                            @click="$emit('checkTracking')"
                        >
                            <i class="fas fa-circle-notch fa-spin" v-if="isLoading"></i>
                            ค้นหา
                        </b-button>
                        </div>
                        <div class="col-12 text-center text-danger" v-if="isError.errorMsg">
                            {{isError.errorMsg}}
                        </div>
                    </div>
                </form>
            </div>
        </div>
        </b-alert>
    </div>
</template>

<script>
export default {
    name:"searchTracking",
    props:{
        isLoading: Boolean,
        isPlaceholder: String,
        isError: Object,
        isTracking: Object,
    },
    methods: {
        clearError( event ) {
            this.isError.errorMsg = false;

            if( this.isTracking.trackingCode.length > 5 ){
                this.$emit('checkTrackingRegx' , event)
            }
        },
        validateTracking(){
            if( this.isTracking.trackingCode.length < 11 || this.isLoading ){
                return false
            }
            this.$emit('checkTracking')
        }
    },
}

</script>